import React from "react";
import {
  Network, FileBarChart, Shield, Users, Key, TrendingUp, History, CalendarDays,
  Radio, Percent, Gauge, UserCheck, Activity, Wallet, LayoutList, DollarSign,
  BadgePercent, Briefcase, PiggyBank, FileText, LayoutDashboard, Settings, Sliders,
  Boxes, Table, Upload, Truck,
} from "lucide-react";

const MAP = {
  network: Network,
  "file-bar-chart": FileBarChart,
  shield: Shield,
  users: Users,
  key: Key,
  settings: Settings,
  sliders: Sliders,
  "trending-up": TrendingUp,
  history: History,
  "calendar-days": CalendarDays,
  radio: Radio,
  percent: Percent,
  gauge: Gauge,
  "user-check": UserCheck,
  activity: Activity,
  wallet: Wallet,
  "layout-list": LayoutList,
  "dollar-sign": DollarSign,
  "badge-percent": BadgePercent,
  briefcase: Briefcase,
  "piggy-bank": PiggyBank,
  "file-text": FileText,
  boxes: Boxes,
  table: Table,
  upload: Upload,
  truck: Truck,
  "layout-dashboard": LayoutDashboard,
};

export function MenuIcon({ name, className }) {
  const Icon = MAP[name] || LayoutDashboard;
  return <Icon className={className} />;
}
